/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Active_BadgeInputs */

const en_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active media version`)
};

const fr_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Version média active`)
};

const de_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Media-Version`)
};

const it_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versione multimediale attiva`)
};

const ru_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версия с активными медиафайлами`)
};

const es_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versión multimedia activa`)
};

const zh_cn2_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动媒体版本`)
};

const ja_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティブメディア版`)
};

const hi_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सक्रिय मीडिया संस्करण`)
};

const pt_pt2_media_tab_active_badge = /** @type {(inputs: Media_Tab_Active_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versão de mídia ativa`)
};

/**
* | output |
* | --- |
* | "Active media version" |
*
* @param {Media_Tab_Active_BadgeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_active_badge = /** @type {((inputs?: Media_Tab_Active_BadgeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Active_BadgeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_media_tab_active_badge(inputs)
	if (locale === "de") return de_media_tab_active_badge(inputs)
	if (locale === "it") return it_media_tab_active_badge(inputs)
	if (locale === "ru") return ru_media_tab_active_badge(inputs)
	if (locale === "es") return es_media_tab_active_badge(inputs)
	if (locale === "zh-CN") return zh_cn2_media_tab_active_badge(inputs)
	if (locale === "ja") return ja_media_tab_active_badge(inputs)
	if (locale === "hi") return hi_media_tab_active_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_media_tab_active_badge(inputs)
	return en_media_tab_active_badge(inputs)
});